import { jwtDecode } from "jwt-decode";

// import { jwtDecode } from 'jwt-decode';
interface ResourceRoles {
    [resourceName: string]: {
        roles: string[];
    };
}

interface DecodedJwt {
    sub: string;
    email?: string;
    name?: string;
    preferred_username?: string;
    given_name?: string;
    family_name?: string;
    resource_access?: ResourceRoles;
}

interface JwtUser {
    sub: string;
    email?: string;
    name?: string;
    preferredUsername?: string;
    givenName?: string;
    familyName?: string;
    resourceRoles: Record<string, string[]>;
}
export function hasPermission(
    jwtToken: string,
    permissions: string[] | string,
): boolean {
    const decoded = parseJwt(jwtToken);
    if (!decoded) {
        return false;
    }
    const userRoles = decoded.resourceRoles["FlightReports"];
    if (Array.isArray(permissions)) {
        return permissions.some((permission) => userRoles.includes(permission));
    } else if (typeof permissions === "string") {
        return userRoles.includes(permissions);
    }
    return false;
}

export function parseJwt(jwtToken: string): JwtUser | null {
    let decoded: DecodedJwt;
    try {
        decoded = jwtDecode<DecodedJwt>(jwtToken);
    } catch (err) {
        console.error("Token:", jwtToken);
        console.error("Failed to decode JWT:", err);
        return null;
    }

    const userInfo: JwtUser = {
        sub: decoded.sub || "",
        email: decoded.email,
        name: decoded.name,
        preferredUsername: decoded.preferred_username,
        givenName: decoded.given_name,
        familyName: decoded.family_name,
        resourceRoles: extractResourceRoles(decoded),
    };

    return userInfo;
}

function extractResourceRoles(
    decodedToken: DecodedJwt,
): Record<string, string[]> {
    const resourceAccess = decodedToken.resource_access;

    if (!resourceAccess) {
        return {};
    }

    const result: Record<string, string[]> = {};

    for (const resourceName of Object.keys(resourceAccess)) {
        const access = resourceAccess[resourceName];
        if (Array.isArray(access.roles)) {
            result[resourceName] = access.roles.filter(
                (role) => typeof role === "string",
            );
        }
    }

    return result;
}
